import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import type { IApiColumnConfig } from '@/creditflowresearch/domain/vo/Bondscreener';
import useColumnsCustomization from './useColumnsCustomization';

export type ColumnsCustomizationContextType = ReturnType<typeof useColumnsCustomization>;

const ColumnsCustomizationContext = createContext<ColumnsCustomizationContextType | null>(null);

export const useColumnsCustomizationContext = (): ColumnsCustomizationContextType => {
  const context = useContext(ColumnsCustomizationContext);

  if (!context) {
    throw new Error('useColumnsCustomizationContext must be used within ColumnsCustomizationProvider');
  }

  return context;
};

interface IColumnsCustomizationProviderProps extends PropsWithChildren {
  allColumns: readonly IApiColumnConfig[],
  activeColumnsIds: readonly string[],
  defaultColumnsIds: readonly string[],
  lockedColumnIds: ReadonlySet<string>,
  onApply: (ids: string[]) => void,
}

export const ColumnsCustomizationProvider = ({
  children,
  allColumns,
  activeColumnsIds,
  defaultColumnsIds,
  lockedColumnIds,
  onApply,
}: IColumnsCustomizationProviderProps): ReactElement => (
  <ColumnsCustomizationContext.Provider
    value={ useColumnsCustomization({
      allColumns,
      activeColumnsIds,
      defaultColumnsIds,
      lockedColumnIds,
      onApply,
    }) }
  >
    { children }
  </ColumnsCustomizationContext.Provider>
);
